import React from 'react';

import { IQuickStartGuideBoxFields } from '../../../types/contentful';

import RichText from '../RichText';

export function QuickStartGuideBox({
  image,
  header,
  text
}: IQuickStartGuideBoxFields) {
  const { file, description } = image?.fields ?? {};

  return (
    <div
      className="py-4 px-1 tablet:py-8 tablet:px-4"
      data-testid="quick-start-box"
    >
      {file && (
        <img
          src={file?.url ?? undefined}
          alt={description ?? ''}
          loading="lazy"
          className="rounded-[56px] w-full"
        />
      )}
      <div
        className="bg-[#F1F1F1] rounded-none tablet:rounded-[56px] -mt-12 pt-16 pr-8 pb-12 pl-8 tablet:pt-[84px] tablet:pr-12 tablet:pb-12 tablet:pl-12 [&_li]:ml-4 tablet:[&_li]:-ml-2"
      >
        <div className="pb-3">
          <h3 className="font-medium text-[22px] leading-6 tablet:text-[26px] tablet:leading-8">
            {header}
          </h3>
        </div>
        {text && <RichText data={text} />}
      </div>
    </div>
  );
}
